<template>
  <div class="box">
    <div class="top typeArea">
        <div class="top-left">
            <div>农药登记试验在农药管理中有着极其重要的作用，事关农业生产安全、农产品质量安全、生态环境安全。贵州健安德核心团队深耕行业20年，累计完成试验10000余项，多次参与国家标准、行业标准制定，拥有非常丰富的经验。试验资质范围覆盖产品化学、毒理学、环境影响等领域，已累计为500多家农药企业提供服务。</div>
            <div @click="$router.push('/aboutUs/contactUs')">
                <img src="@/assets/images/image57.png" alt="">
                <span>联系我们</span>
            </div>
        </div>
        <div class="top-right">
            <defaultImg class="banner" :src="require('@/assets/images/image56.png')"></defaultImg>
        </div>
    </div>
    <div class="bottom">
        <!-- <cusTable :tableData="tableData"></cusTable> -->
        <div class="tableBox typeArea"> 
            <cusTable :tableData="tableData1" class="tableItem" rowHeight="66px"></cusTable>
            <cusTable :tableData="tableData2" class="tableItem" rowHeight="36px" fieldColumnName="试验领" secondFieldColumnName="域"></cusTable>
        </div>
        <div class="historyBox">
            <div class="historyBox-title">农药登记试验单位资质历程</div>
            <historyCarousel :historyList="historyList"></historyCarousel>
        </div>
        <!-- <el-tabs class="tabs" v-model="activeName" @tab-click="{}">
            <el-tab-pane label="产品化学试验项目" name="first">
                <tabContent class="mg-top40" :dataList="dataList1"></tabContent>
            </el-tab-pane>
            <el-tab-pane label="健康毒理试验项目" name="second">
                <tabContent class="mg-top40" :dataList="dataList2"></tabContent>
            </el-tab-pane>
            <el-tab-pane label="环境影响试验项目" name="third">
                <div class="switch">
                    <div :class="switchBtn==1?'switch-active':'switch-default'" @click="switchBtn=1">生态毒理试验项目</div>
                    <div :class="switchBtn==2?'switch-active':'switch-default'" @click="switchBtn=2">环境归趋试验项目</div>
                </div>
                <tabContent v-if="switchBtn==1" :dataList="dataList3"></tabContent>
                <tabContent v-if="switchBtn==2" :dataList="dataList4"></tabContent>
            </el-tab-pane>
        </el-tabs> -->
    </div>
  </div>
</template>

<script>
import tabContent from '@/views/ourService/components/tabContent'
import historyCarousel from '../../components/historyCarousel/historyCarousel.vue';
export default {
  name: 'ourServicePesticide',
  components:{tabContent,historyCarousel},
  data () {
    return {
        activeName: 'first',
        dataList1:{
            total:5,
            list:[{
                src: require('@/assets/images/image58.png'),
                title: "（全）组分分析"
            },{
                src: require('@/assets/images/image75.png'),
                title: "理化性质测定"
            },{
                src: require('@/assets/images/image76.png'),
                title: "产品质量检测"
            },{
                src: require('@/assets/images/image77.png'),
                title: "储存稳定性"
            },{
                src: require('@/assets/images/image78.png'),
                title: "分析方法验证与确认"
            }]
        },
        dataList2:{
            total:7,
            list:[{
                src: require('@/assets/images/image79.png'),
                title: "急性经口毒性"
            },{
                src: require('@/assets/images/image80.png'),
                title: "急性经皮毒性"
            },{
                src: require('@/assets/images/image81.png'),
                title: "急性吸入毒性"
            },{
                src: require('@/assets/images/image82.png'),
                title: "皮肤腐蚀/刺激"
            },{
                src: require('@/assets/images/image83.png'),
                title: "眼刺激"
            },{
                src: require('@/assets/images/image84.png'),
                title: "皮肤致敏"
            },{
                src: require('@/assets/images/image85.png'),
                title: "健康风险评估报告"
            }]
        },
        dataList3:{
            total:14,
            list:[{
                src: require('@/assets/images/image86.png'),
                title: "鸟类急性经口毒性"
            },{
                src: require('@/assets/images/image87.png'),
                title: "鸟类急性饲喂毒性"
            },{
                src: require('@/assets/images/image88.png'),
                title: "鱼类急性毒性试"
            },{
                src: require('@/assets/images/image89.png'),
                title: "鱼类急性毒性试"
            },{
                src: require('@/assets/images/image90.png'),
                title: "藻类生长抑制"
            },{
                src: require('@/assets/images/image91.png'),
                title: "浮萍生长抑制"
            },{
                src: require('@/assets/images/image92.png'),
                title: "穗状狐尾藻毒性"
            },{
                src: require('@/assets/images/image93.png'),
                title: "蜜蜂急性经口毒性"
            },{
                src: require('@/assets/images/image94.png'),
                title: "蜜蜂急性接触毒性"
            },{
                src: require('@/assets/images/image95.png'),
                title: "家蚕急性毒性"
            },{
                src: require('@/assets/images/image96.png'),
                title: "天敌赤眼蜂急性毒性"
            },{
                src: require('@/assets/images/image97.png'),
                title: "天敌（瓢虫）急性接触毒性"
            },{
                src: require('@/assets/images/image98.png'),
                title: "蚯蚓急性毒性"
            },{
                src: require('@/assets/images/image99.png'),
                title: "环境风险评估报告"
            }]
        },
        dataList4:{
            total:7,
            list:[{
                src: require('@/assets/images/image100.png'),
                title: "水解试验"
            },{
                src: require('@/assets/images/image101.png'),
                title: "土壤淋溶"
            },{
                src: require('@/assets/images/image102.png'),
                title: "水中光解"
            },{
                src: require('@/assets/images/image103.png'),
                title: "土壤吸附"
            },{
                src: require('@/assets/images/image104.png'),
                title: "土壤表面光解"
            },{
                src: require('@/assets/images/image105.png'),
                title: "农药在水中的分析方法验证"
            },{
                src: require('@/assets/images/image106.png'),
                title: "农药在土壤中的分析方法验证"
            }]
        },
        switchBtn:1,
        tableData: [
            {
                field: '产品化学试验项目',
                project: '（全）组分分析试验',
                period: '初筛后确定'
            },
            {
                field: '产品化学试验项目',
                project: '有效成分理化性质试验',
                period: '6'
            },
            {
                field: '产品化学试验项目',
                project: '原药理化性质试验',
                period: '3'
            },
            {
                field: '产品化学试验项目',
                project: '制剂理化性质试验',
                period: '2'
            },
            {
                field: '环境毒理试验项目',
                project: '蜜蜂急性经口毒性试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '蜜蜂急性接触毒性试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '天敌赤眼蜂急性毒性试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '家蚕急性毒性试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '蚯蚓急性毒性试验',
                period: '6'
            },
            {
                field: '环境毒理试验项目',
                project: '鸟类急性经口毒性试验',
                period: '6'
            },
            {
                field: '环境毒理试验项目',
                project: '大型溞类急性活动抑制试验',
                period: '6'
            },
            {
                field: '环境毒理试验项目',
                project: '绿藻生长抑制试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '鱼类急性毒性试验',
                period: '4'
            },
            {
                field: '环境毒理试验项目',
                project: '天敌（瓢虫）急性接触毒性试验',
                period: '6'
            },
            {
                field: '环境毒理试验项目',
                project: '水生植物毒性试验（浮萍生长抑制试验）',
                period: '8'
            },
            {
                field: '环境毒理试验项目',
                project: '水生植物毒性试验（穗状狐尾藻毒性试验）',
                period: '8'
            },
            {
                field: '环境毒理试验项目',
                project: '风险评估报告',
                period: '3'
            },
            {
                field: '环境归趋试验项目',
                project: '农药在水中的分析方法建立',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '农药在土壤中的分析方法建立',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '农药在水中的分析方法验证试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '农药在土壤中的分析方法验证试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '水解试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '水中光解试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '土壤表面光解试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '土壤淋溶试验',
                period: '6'
            },
            {
                field: '环境归趋试验项目',
                project: '土壤吸附试验',
                period: '6'
            },
            {
                field: '毒理学试验项目',
                project: '急性经口毒性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '急性经皮毒性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '皮肤刺激性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '眼睛刺激性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '皮肤致敏性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '急性吸入毒性试验',
                period: '3'
            },
            {
                field: '毒理学试验项目',
                project: '健康风险评估报告',
                period: '3'
            },
        ],
        tableData1: [
            {
                field: '产品化学试验项目',
                project: '（全）组分分析试验',
                period: '初筛后确定',
                index: 1
            },
            {
                field: '产品化学试验项目',
                project: '理化性质测定试验',
                period: '2-6',
                index: 2
            },
            {
                field: '产品化学试验项目',
                project: '产品质量检测及方法验证',
                period: '3-5',
                index: 3
            },
            {
                field: '产品化学试验项目',
                project: '储存稳定性试验',
                period: '26',
                index: 4
            },
            {
                field: '产品化学试验项目',
                project: '方法确认',
                period: '3-5',
                index: 5
            },
            {
                field: '毒理学试验项目',
                project: '急性经口毒性试验',
                period: '3',
                index: 6
            },
            {
                field: '毒理学试验项目',
                project: '急性经皮毒性试验',
                period: '3',
                index: 7
            },
            {
                field: '毒理学试验项目',
                project: '皮肤刺激性试验',
                period: '3',
                index: 8
            },
            {
                field: '毒理学试验项目',
                project: '眼睛刺激性试验',
                period: '3',
                index: 9
            },
            {
                field: '毒理学试验项目',
                project: '皮肤致敏性试验',
                period: '3',
                index: 10
            },
            {
                field: '毒理学试验项目',
                project: '急性吸入毒性试验',
                period: '3',
                index: 11
            },
            {
                field: '毒理学试验项目',
                project: '健康风险评估报告',
                period: '3',
                index: 12
            },
        ],
        tableData2: [
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '蜜蜂急性经口毒性试验',
                period: '4',
                index: 13
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '蜜蜂急性接触毒性试验',
                period: '4',
                index: 14
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '天敌赤眼蜂急性毒性试验',
                period: '4',
                index: 15
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '家蚕急性毒性试验',
                period: '4',
                index: 16
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '蚯蚓急性毒性试验',
                period: '6',
                index: 17
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '鸟类急性经口毒性试验',
                period: '6',
                index: 18
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '大型溞类急性活动抑制试验',
                period: '6',
                index: 19
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '绿藻生长抑制试验',
                period: '4',
                index: 20
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '鱼类急性毒性试验',
                period: '4',
                index: 21
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '天敌（瓢虫）急性接触毒性试验',
                period: '6',
                index: 22
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '水生植物毒性试验（浮萍生长抑制试验）',
                period: '8',
                index: 23
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '水生植物毒性试验（穗状狐尾藻毒性试验）',
                period: '8',
                index: 24
            },
            {
                field: '环境试验项目',
                secondField: '生态毒理A类试验',
                project: '风险评估报告',
                period: '3',
                index: 25
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '农药在水中的分析方法建立',
                period: '6',
                index: 26
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '农药在土壤中的分析方法建立',
                period: '6',
                index: 27
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '农药在水中的分析方法验证试验',
                period: '6',
                index: 28
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '农药在土壤中的分析方法验证试验',
                period: '6',
                index: 29
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '水解试验',
                period: '6',
                index: 30
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '水中光解试验',
                period: '6',
                index: 31
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '土壤表面光解试验',
                period: '6',
                index: 32
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '土壤淋溶试验',
                period: '6',
                index: 33
            },
            {
                field: '环境试验项目',
                secondField: '环境归趋A类试验',
                project: '土壤吸附试验',
                period: '6',
                index: 34
            },
        ],
        historyList:[
            {
                date: '2013.01',
                title:['《农药登记试验单位》'],
                subtitle:['--原药全组分分析'],
                certification:{
                    name: '农业农村部',
                    src: [require("@/assets/images/image163.jpg")]
                }
            },
            {
                date: '2014.08',
                title:['《农药登记试验单位》'],
                subtitle:['--环境毒理'],
                certification:{
                    name: '农业农村部',
                    src: [require('@/assets/images/image164.jpg')]
                }
            },
            {
                date: '2015.02',
                title:['CNAS GLP','《良好实验室规范符合性证书》'],
                subtitle:[],
                certification:{
                    name: '国家认可委',
                    src: [require('@/assets/images/image165.jpg')]
                }
            },
            {
                date: '2016.08',
                title:['《农药登记试验单位》'],
                subtitle:['--全组分分析、理化分析','（公告更新）'],
                certification:{
                    name: '农业农村部',
                    src: [require('@/assets/images/image166.jpg'),require('@/assets/images/image167.jpg')]
                }
            },
            {
                date: '2018.06',
                title:['CNAS GLP','《良好实验室规范符合性证书》'],
                subtitle:['（证书更新）'],
                certification:{
                    name: '国家认可委',
                    src: [require('@/assets/images/image168.jpg')]
                }
            },
            {
                date: '2019.03',
                title:['《农药登记试验单位》'],
                subtitle:['（证书更新）'],
                certification:{
                    name: '农业农村部',
                    src: [require('@/assets/images/image169.jpg')]
                }
            },
            {
                date: '2019.04',
                title:['CNAS GLP','《良好实验室规范符合性证书》'],
                subtitle:['（证书更新）'],
                certification:{
                    name: '国家认可委',
                    src: [require('@/assets/images/image170.jpg')]
                }
            },
            {
                date: '2021.06',
                title:['CNAS','《实验室认可证书》'],
                subtitle:[],
                certification:{
                    name: '国家认可委',
                    src: [require('@/assets/images/image171.jpg')]
                }
            },
            {
                date: '2021.06',
                title:['CNAS GLP','《良好实验室规范符合性证书》'],
                subtitle:['（证书更新）'],
                certification:{
                    name: '国家认可委',
                    src: [require('@/assets/images/image172.jpg')]
                }
            },
        ]
    }
  },
  methods: {

  },
}
</script> 

<style lang='less' scoped>
    .bottom{
        margin-top: 80px;
    }
</style>
